(
    function (skyward, $)
    {
        "use strict";

        $(function ()
        {
            var headerSearchButton = $("#searchButton");

            headerSearchButton.on("click", function ()
            {
                globalSearch.show();
            });
        });

        var globalSearch = (function ()
        {
            var globalSearch = {};
            var dialog;
            var searchBox;
            var searchButton;
            var searchResultsDiv;
            var allowSearch = true;

            globalSearch.show = function ()
            {
                dialog = skyward.modalLayer.showDialog("Global Search", createSearchContainerContents, { text: "Close", icon: "Close" }, { draggable: true, closeOnClick: false, width: '95%' });

                searchBox.attr("placeholder", "Search"); // Seems like the placeholder attribute must be set after the input is put into the DOM

                searchButton.on("click", function ()
                {
                    if (allowSearch)
                    {
                        allowSearch = false;
                        skyward.controls.disable(searchBox);
                        skyward.controls.disable(searchButton);
                        performSearch(searchBox.val()).done(function () { allowSearch = true; skyward.controls.enable(searchBox); skyward.controls.enable(searchButton); searchBox.focus(); });
                    }
                });

                searchBox.on("keyup", function (event)
                {
                    if (allowSearch && event.keyCode == 13)
                    {
                        searchButton.click();
                    }
                });
            };

            function createSearchContainerContents()
            {
                var wrapper = $("<div>");
                var searchBoxWrapper = $("<div>", { class: "globalSearchBoxWrapper browseSearch", role: "search" });
                searchBox = $("<input>", { type: "text", class: "globalSearchBox browseSearchBox", autofocus: "true", role: "searchbox", "aria-label": "Global Search" });
                searchButton = $("<a>", { href: "javascript:void(0)", class: "button ButtonIconOnly", role: "button", "aria-label": "Perform Search" });
                searchResultsDiv = $("<div>", { class: "searchResultsContainer", role: "region", "aria-label": "Search Results", "aria-live": "polite" });

                var svg = skyward.svg.getSvg("Search", "svgBrowseFooter");
                searchButton.append(svg);
                searchBoxWrapper.append(searchBox).append(searchButton);
                wrapper.append(searchBoxWrapper).append(searchResultsDiv);

                return wrapper;
            }

            function createSearchResultHeader(headerLabel)
            {
                var div = $("<div>", { class: "sectionHeader" });
                var h3 = $("<h3>", { class: "sectionHeader__text" }).text(headerLabel);

                return div.append(h3);
            }

            function performSearch(searchText)
            {
                var promise = $.ajax(
                    {
                        url: skyward.global.virtualDir + "SkySys/GlobalSearch/Search",
                        type: "POST",
                        dataType: "JSON",
                        data: { searchText: skyward.extensions.encodeHtml(searchText) },
                        activityIndicator: { hideGlass: true },
                        success: function (response)
                        {
                            displaySearchResults(response);
                        }
                    }
                );

                $.wait(500).done(function ()
                {
                    if (promise.state() === "pending")
                    {
                        searchResultsDiv.html(createLoadingGif());
                    }
                });

                return promise;
            }

            function displaySearchResults(response)
            {
                var searchResults = response.result;
                var tempHtml = $("<div>");

                var labelAreaClass = "js-labelArea";
                var descAreaClass = "js-descriptionArea";
                var idPrefix = "searchResult-";

                if (!searchResults || searchResults.length == 0)
                {
                    searchResultsDiv.html("<div class='noRecordsInBrowse browseRow'><p>No results found</p></div>");

                    return;
                }

                for (var i = 0; i < searchResults.length; i++)
                {
                    var searchResultArea = searchResults[i];
                    tempHtml.append(createSearchResultHeader(searchResultArea.header));

                    for (var j = 0; j < searchResultArea.results.length; j++)
                    {
                        var resultRecord = searchResultArea.results[j];
                        var piece = $("<a>", { class: "searchResult", attr: resultRecord.Data, href: "javascript:void(0)", target: "_blank" });
                        piece.attr("data-click-action", searchResultArea.clickAction);
                        piece.append(resultRecord.Html);

                        var pieceId = piece.data("id");

                        var labelArea = piece.find(labelAreaClass.dot());
                        if (labelArea.length)
                        {
                            var labelId = idPrefix + pieceId + "-label";
                            labelArea.attr("id", labelId);
                            piece.attr("aria-labelledby", labelId);
                        }

                        var descArea = piece.find(descAreaClass.dot());
                        if (descArea.length)
                        {
                            var desclId = idPrefix + pieceId + "-desc";
                            descArea.attr("id", desclId);
                            piece.attr("aria-describedby", desclId);
                        }

                        tempHtml.append(piece);
                    }
                }

                searchResultsDiv.html(tempHtml.html());
                dialog.animateModalContents();
            }

            function createLoadingGif()
            {
                var imageContainer = $("<div>", { class: "skywardLoadContainer" });
                var image = $("<img>", { class: "skywardLoadContainer__spinner", src: skyward.global.virtualDir + "content/loading.gif?v=2", alt: "Loading Image" });
                var loadingText = $("<p>", { class: "skywardLoadContainer__message", text: "Searching, please wait." });

                return imageContainer.append(image).append(loadingText);
            }

            function openNewWindow()
            {
                // Stolen from window.loadContent since it closes the top popup for some reason.
                var data = $(this).data();
                var url = skyward.global.virtualDir + data.url + (data.id !== undefined ? "/" + data.id : "");
                var formData = $.extend({}, data);
                skyward.window.submitForm(url, formData, { openNewWindow: true });
            }

            skyward.events.registerEvents("globalSearch", { "openNewWindow": openNewWindow });

            return globalSearch;
        })();

    }(window.skyward = window.skyward || {}, window.jQuery)
);
